import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

// Context
import { AuthProvider } from './context/AuthContext';

// Components
import AppNavbar from './components/AppNavbar';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LoginPage from './pages/auth/LoginPage';
import ProfilePage from './pages/auth/ProfilePage';
import HomePage from './pages/HomePage';
import UploadPage from './pages/upload/UploadPage';
import CsvListPage from './pages/upload/CsvListPage';
import CsvDetailPage from './pages/upload/CsvDetailPage';
import LeadsPage from './pages/lead/LeadsPage';
import CampaignListPage from './pages/campaign/CampaignListPage';
import CampaignDetailPage from './pages/campaign/CampaignDetailPage';
import UserManagementPage from './pages/admin/UserManagementPage';
import CibilUploadPage from './pages/admin/CibilUploadPage';
import CreateCampaignPage from './pages/campaign/CreateCampaignPage';
import MappingManagementPage from './pages/admin/MappingManagementPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppNavbar />
        <div className="container mt-4">
          <Routes>
            {/* Public route - Login */}
            <Route path="/login" element={<LoginPage />} />

            {/* Protected routes */}
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              }
            />

            {/* Upload module - accessible to makers and admins */}
            <Route
              path="/upload"
              element={
                <ProtectedRoute allowedRoles={["maker", "admin"]}>
                  <UploadPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/csvs"
              element={
                <ProtectedRoute
                  allowedRoles={["maker", "cibil_uploader", "admin"]}
                >
                  <CsvListPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/csvs/:csvId/leads"
              element={
                <ProtectedRoute
                  allowedRoles={["maker", "cibil_uploader", "admin"]}
                >
                  <CsvDetailPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/leads"
              element={
                <ProtectedRoute allowedRoles={["campaign_manager", "admin"]}>
                  <LeadsPage />
                </ProtectedRoute>
              }
            />

            {/* Campaign module - accessible to campaign managers and admins */}
            <Route
              path="/campaigns"
              element={
                <ProtectedRoute allowedRoles={["campaign_manager", "admin"]}>
                  <CampaignListPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/campaigns/new"
              element={
                <ProtectedRoute allowedRoles={["campaign_manager", "admin"]}>
                  <CreateCampaignPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/campaigns/:id"
              element={
                <ProtectedRoute allowedRoles={["campaign_manager", "admin"]}>
                  <CampaignDetailPage />
                </ProtectedRoute>
              }
            />

            {/* Profile page - accessible to all authenticated users */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />

            {/* User Management page - accessible only to admins */}
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <UserManagementPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin/mappings"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <MappingManagementPage />
                </ProtectedRoute>
              }
            />

            {/* CIBIL Upload page - accessible only to admins */}
            <Route
              path="/cibil-upload"
              element={
                <ProtectedRoute allowedRoles={["cibil_uploader", "admin"]}>
                  <CibilUploadPage />
                </ProtectedRoute>
              }
            />

            {/* Redirect root to login */}
            <Route path="/" element={<Navigate to="/login" />} />

            {/* Catch all other routes */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;